import BaseAPI from "../base";

class ComplaintService extends BaseAPI {
  //
  getGroupsByLevel(data) {
    return this.post({
      url: "/YuanHe/Complaint/WorkGetGroupsByLevel",
      data,
    });
  }

  // 工单详情
  getWorkDetail(data) {
    return this.post({
      url: "/YuanHe/Complaint/WorkDetail",
      data,
    });
  }

  // 投诉工单枚举
  getComplaintAllEnum() {
    return this.get({
      url: "/YuanHe/Complaint/GetComplaintAllEnum",
    });
  }

  // 投诉工单保存处理组
  workDealGroupEdit(data) {
    return this.post({
      url: "/YuanHe/Complaint/WorkDealGroupEdit",
      data,
    });
  }

  // 投诉工单升级
  workLevelUpdate(data) {
    return this.post({
      url: "/YuanHe/Complaint/WorkLevelUpdate",
      data,
    });
  }

  // 工单列表
  workList(data) {
    return this.post({
      url: "/YuanHe/Complaint/WorkList",
      data,
    });
  }
}

export default new ComplaintService();
